import classes from './DetailsV2.module.scss'

const certificateFields = [
  {
    id: 'certificateScheme',
    display: 'Certification Scheme',
  },
  {
    id: 'certificateNumber',
    display: 'Certificate Number',
  },
  {
    id: 'issueDate',
    display: 'Issue Date',
  },
  {
    id: 'expirationDate',
    display: 'Expiration Date',
  },
  {
    id: 'projectNumber',
    display: (details: any) =>
      details?.certificateDetails?.isServiceRequestNumber
        ? 'Service Request Number'
        : 'Project Number',
    value: (details: any) =>
      details?.certificateDetails?.isServiceRequestNumber
        ? details?.certificateDetails?.serviceRequestNumber
        : details?.projectNumber,
  },
  {
    id: 'certificationBody',
    display: 'Certification Body',
  },
  {
    id: 'country',
    display: 'Country',
  },
  {
    id: 'customerCompanyName',
    display: 'Customer Company Name',
    parent: 'certificateDetails',
    showIf: (details: any) =>
      details?.certificateDetails?.isServiceRequestNumber,
  },
  {
    id: 'productOwner',
    display: 'Product Owner',
  },
  {
    id: 'productName',
    display: 'Product Name',
  },
  {
    id: 'brand',
    display: 'Trademark/Brand',
  },
  {
    id: 'productCategory',
    display: 'Product Category',
  },
  {
    id: 'deliverable',
    display: 'Deliverable',
  },
  {
    id: 'licenseHolder',
    display: 'License Holder',
  },
]

const certificateFieldsRevision = [
  {
    id: 'certificateScheme',
    display: 'Certification Scheme',
  },
  {
    id: 'certificateNumber',
    display: 'Certificate Number',
  },
  {
    id: 'issueDate',
    display: 'Issue Date',
  },
  {
    id: 'expirationDate',
    display: 'Expiration Date',
  },
  {
    id: 'revisionNumber',
    display: 'Revision Number',
  },
  {
    id: 'projectNumber',
    display: 'Project Number',
  },
  {
    id: 'certificationBody',
    display: 'Certification Body',
  },
  {
    id: 'country',
    display: 'Country',
  },
  {
    id: 'productName',
    display: 'Product Name',
  },
  {
    id: 'brand',
    display: 'Trademark/Brand',
  },
  {
    id: 'deliverable',
    display: 'Deliverable',
  },
  {
    id: 'productOwner',
    display: 'Product Owner (Ship To)',
  },
  {
    id: 'mark',
    display: 'Mark',
  },
  {
    id: 'standard',
    display: 'Standard',
  },
]

interface DetailsV2Props {
  details: any
  isRevision: boolean
  isExpanded: boolean
}

const DetailsV2 = (props: DetailsV2Props) => {
  const getDisplay = (c: any) =>
    typeof c.display === 'function' ? c.display(props.details) : c.display

  const getValue = (c: any) => {
    if (c.value) {
      return c.value(props.details)
    }

    if (c.parent) {
      return props.details?.[c.parent]?.[c.id]
    }

    return props.details?.[c.id]
  }

  return props.details && !props.isRevision ? (
    <div className={`${classes['certificate-details__container']}`}>
      {certificateFields
      .filter(c => !c.showIf || c.showIf(props.details))
      .map((c, i) => (
        <div key={i} className="ul-grid__row">
          <div
            className={`ul-grid__column ${
              props.isExpanded ? '-x30' : `-x50 ${classes['details-overflow-wrap']}`
            }`}
          >
            <span>{getDisplay(c)}</span>
          </div>
          <div
            className={`ul-grid__column ${
              props.isExpanded ? '-x70' : `-x50 ${classes['details-overflow-wrap']}`
            }`}
          >
            <span>{getValue(c)}</span>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className={`${classes['certificate-details__container']}`}>
      {certificateFieldsRevision.map((c, i) => (
        <div key={i} className="ul-grid__row">
          <div
            className={`ul-grid__column ${
              props.isExpanded ? '-x30' : `-x50 ${classes['details-overflow-wrap']}`
            }`}
          >
            <span>{c.display}</span>
          </div>
          <div
            className={`ul-grid__column ${
              props.isExpanded ? '-x70' : `-x50 ${classes['details-overflow-wrap']}`
            }`}
          >
            <span>{props.details[c.id]}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default DetailsV2
